import { render, staticRenderFns } from "./HomeSummary.vue?vue&type=template&id=53bcccba&scoped=true&"
import script from "./HomeSummary.vue?vue&type=script&lang=js&"
export * from "./HomeSummary.vue?vue&type=script&lang=js&"
import style0 from "./HomeSummary.vue?vue&type=style&index=0&id=53bcccba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bcccba",
  null
  
)

export default component.exports